import React, { useState } from "react";
import { Scroll, TableInstance } from "../../styled";
import { useTable, usePagination, useExpanded, useRowSelect, useFlexLayout } from "react-table";
import Header from "./components/Header";
import Body from "./components/Body";
import Footer from "./components/Footer";

const Structure = ({ columns, data }) => {
  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = useTable(
    {
      columns,
      data,
      editableRowIndex,
      setEditableRowIndex,
      initialState: { pageSize: 1000 },
      autoResetExpanded: false,
      autoResetSelectedRows: false,
    },
    useExpanded,
    usePagination,
    useRowSelect,
    useFlexLayout,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          disableResizing: false,
          minWidth: 35,
          width: 35,
          maxWidth: 35,
        },
        ...columns,
      ]);
    }
  );
  return (
    <TableInstance {...getTableProps()}>
      <Header data={headerGroups} />
      <Scroll>
        <Body getTableBodyProps={getTableBodyProps} data={page} prepareRow={prepareRow} />
      </Scroll>
      <Footer />
    </TableInstance>
  );
};

export default Structure;
